import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useLayoutEffect } from 'react';
import { ConditionScope } from './ConditionScope';
export const Condition = (props)=>{
    const { washFields, behavior, preserveContext, children, componentClass, if: ifProp, ...propsToPass } = props;
    const conditionCtxRef = useRef(undefined);
    const prevIf = useRef(ifProp);
    const ComponentClass = componentClass || 'div';
    /**
     * Utan effect skrivs varning ut i consolen: "Cannot update a component ... while rendering a different component.
     * Med useEffect hinner children unmountas (och useClearable-callbacks avregistreras) innan rensningen körs.
     * Med useLayoutEffect blir det korrekt: inga fel i console och clear körs innan barnkomponenter unmountas.
     */ useLayoutEffect(()=>{
        if (prevIf.current && !ifProp) {
            conditionCtxRef.current?.clear();
        }
        prevIf.current = ifProp;
    });
    return /*#__PURE__*/ _jsx(ConditionScope, {
        washFields: washFields,
        preserveContext: preserveContext,
        onSetContext: (ctx)=>{
            return conditionCtxRef.current = ctx;
        },
        children: (!!ifProp || behavior === 'none') && /*#__PURE__*/ _jsx(ComponentClass, {
            ...propsToPass,
            children: children
        })
    });
};
